
<template>
  <v-app>
    <v-content>
      <div class="container" style="max-width: 850px">
        <div>
          <img width="120" src="/images/premiere-logo-blue.svg" />
        </div>
        <router-view />
      </div>
    </v-content>
    <v-footer>
      <div class="container" style="max-width: 850px">
        <div style="width:100%">
          <div class="d-flex justify-center"><img height="60" src="/images/cumis/Cooperators-logo-blue-2X-1.png" /></div>
          <div class="text-muted text-center" style="font-size: 0.6em;">
            <span v-if="isPage1"><sup>1</sup>Ipsos | <sup>2</sup>CorHealth Ontario | <sup>3</sup>Canadian Cancer Society</span><br/>
            Creditor's group insurance is underwritten by Co-operators Life Insurance Company. Supporting services, such as enrolment intake, medical underwriting, and claims administration, are provided by the employees of CUMIS Services Incorporated, a subsidiary of Co-operators Life Insurance Company. Co-operators® is a registered trademark of The Co-operators Group Limited.
          </div>
        </div>
      </div>
    </v-footer>
  </v-app>
</template>
<script>
import { EventBus } from "@/services/eventBus";
export default{
  data(){
    return{
      isPage1: false,
    };
  },
created() {
  document.title='Co-operators Life Insurance';
  EventBus.$on('flagChanged', (isPage1) => {this.isPage1 = isPage1;});
},
}
</script>